module.exports = __webpack_public_path__ + "static/media/world_green.12fa2dcb.png";